import React, { useState, useEffect } from "react";
import ConnectAPI from "../../../services/api";
import { authenticationService } from "../../../services/context/AuthService";
import Swal from "sweetalert2";
import moment from "moment";
import {IconDownload, Select, Button, Search, Table, Tabs } from "@veneer/core";
import SpecialConditionDetail from "./SpecialConditionDetailAll";
import { useTranslation } from "react-i18next";
import XLSX from 'xlsx';
import $ from 'jquery';

const connectApi = new ConnectAPI();
function SpecialConditionReport(props) {
  const { id } = props.match.params;
  const [tableData, setTableData] = useState([]);
  const [tableDataIn,setTableDataIn]=useState([]);
  const [tableDataStand,setTableDataStand]=useState([]);
  const [tableRejected, setTableRejected]=useState([]);
  const [tablePending, setTablePending]=useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTabIndex, setactiveTabIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPage_in, setCurrentPage_in] = useState(1);
  const [currentPage_stan, setCurrentPage_stan] = useState(1);
  const [currentPage_rej, setCurrentPage_rej] = useState(1);
  const [currentPage_pen, setCurrentPage_pen] = useState(1);
  const [idSC,setidSC]=useState(0);
  const handlePageChange = (page) => setCurrentPage(page);
  const handlePageChange_in = (page) => setCurrentPage_in(page);
  const handlePageChange_stan = (page) => setCurrentPage_stan(page);
  const handlePageChange_rej = (page) => setCurrentPage_rej(page);
  const handlePageChange_pen = (page) => setCurrentPage_pen(page);
  const [pageSize, setPageSize] = useState(15);
  const [selectEnddate, setselectEnddate]=useState([]);
  const [selectEnddate_in, setselectEnddate_in]=useState([]);
  const [selectEnddate_stan, setselectEnddate_stan]=useState([]);
  const [selectEnddate_rej, setselectEnddate_rej]=useState([]);
  const [selectEnddate_pend, setselectEnddate_pend]=useState([]);

  const [selectStartDate, setselectStartDate]=useState([]);
  const [selectStartDate_in, setselectStartDate_in]=useState([]);
  const [selectStartDate_stan, setselectStartDate_stan]=useState([]);
  const [selectStartDate_rej, setselectStartDate_rej]=useState([]);
  const [selectStartDate_pend, setselectStartDate_pend]=useState([]);

  const [globalaccount, setglobalaccount]=useState([]);
  const { t } = useTranslation();
  
  useEffect(() => {
    //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    if (currentUser?.urls && Array.isArray(currentUser.urls)) {
      const currentPath = window.location.pathname;
      currentUser.urls.forEach(ur => {
        if (currentPath.startsWith(ur)) validate = true;
      });
    }
    if (!validate){
      const { history } = props;
        history.push({
          pathname: '/' 
        });
    }
    let email = authenticationService.currentUserValue.email
    const fetchData = async () => {
        connectApi.getWithParams("api/Channels/specialConditionsAll", email, getSCdataCallback)
        .catch ((error) => {
          setIsLoading(false);
          Swal.fire(
              "Error " + error?.response?.status,
              error?.response?.data,
              "error"
          );
        });
        setIsLoading(true);
    }
    fetchData();
  }, [idSC]);

  const selectTab = (event) => (index) => {
    setactiveTabIndex(index);
  };
  const getSCdataCallback = (status, data) => {
    
    const formatDateOptions = dates => dates.map(date => ({ value: date, label: date }));

    const pendingflag=data.pending.tasks.map(task=>({
      ...task, isGlobal:
      data.globalaccounts.includes(task.idEndUser)
    }));
    const activesc=data.active.tasks.map(task=>({
      ...task, isGlobal:
      data.globalaccounts.includes(task.idEndUser)
    }));
    const inActivesc=data.inActive.tasks.map(task=>({
      ...task, isGlobal:
      data.globalaccounts.includes(task.idEndUser)
    }));
    const standbysc=data.standby.tasks.map(task=>({
      ...task, isGlobal:
      data.globalaccounts.includes(task.idEndUser)
    }));
    const rejected=data.rejected.tasks.map(task=>({
      ...task, isGlobal:
      data.globalaccounts.includes(task.idEndUser)
    }));


    setTableData(activesc);
    setselectStartDate(formatDateOptions(data.active.startDates));
    setselectEnddate(formatDateOptions(data.active.endDates));

    setTableDataIn(inActivesc);
    setselectStartDate_in(formatDateOptions(data.inActive.startDates));
    setselectEnddate_in(formatDateOptions(data.inActive.endDates));

    setTableDataStand(standbysc);
    setselectStartDate_stan(formatDateOptions(data.standby.startDates));
    setselectEnddate_stan(formatDateOptions(data.standby.endDates));

    setTableRejected(rejected);
    setselectStartDate_rej(formatDateOptions(data.rejected.startDates));
    setselectEnddate_rej(formatDateOptions(data.rejected.endDates));
    setglobalaccount(data.globalaccounts)

    setTablePending(pendingflag);
    setselectStartDate_pend(formatDateOptions(data.pending.startDates));
    setselectEnddate_pend(formatDateOptions(data.pending.endDates));

    setIsLoading(false);
    
  }
  function descendingComparator(a, b, orderBy) {
    const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
    const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
    
    
    if (orderBy=="idSpecialCondition"){
      if (parseInt(bSort) < parseInt(aSort)) {
        return -1;
      }
      if (parseInt(bSort) > parseInt(aSort)) {
        return 1;
      }
    }else if(orderBy=="startDate" || orderBy=="endDate"){
      if (Date.parse(bSort) < Date.parse(aSort)) {
        return -1;
      }
      if (Date.parse(bSort) > Date.parse(aSort)) {
        return 1;
      }
    }else{
      if (bSort < aSort) {
        return -1;
      }
      if (bSort > aSort) {
        return 1;
      }
    }
    
    return 0;
  }

  function sort(array, orderBy, orderType) { 
    return array.sort((a, b) => {
      const value = (orderType === 'descending')
        ? descendingComparator(a, b, orderBy)
        : -descendingComparator(a, b, orderBy);
  
      return value;
    });
  }
  function filter(array, filters) {
    let arrayFiltered = array;
    Object.keys(filters).forEach((value) => {
      const filterValue = filters[value];
      const filter = typeof filterValue === 'object' ? filterValue[0] : filterValue;
      if (filter) {
        arrayFiltered = arrayFiltered.filter((a) => {
          const aUpper = a[value] && a[value].toString().toUpperCase();
          const filterUpper = filter && filter.toString().toUpperCase();
          return aUpper.indexOf(filterUpper) > -1;
        });
      }
    });
    return arrayFiltered;
  }
  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  
  //Views
  const MyTableApp = () => {
    const [showSCDetail, setShowSCDetail] = useState(false);
    const [specialConditionDetail, setSpecialConditionDetail] = useState([]);
    function activateLasers(e) {
      var id = $(e.target).closest('tr').children().eq(0).text();
      if (id!=t('Special Condition') && id!=""){
          let sc = tableData.find(sc => sc.idSpecialCondition == id);
          setSpecialConditionDetail(sc);
          setShowSCDetail(true);
      }
    }
    const onClodeModal = () => {
      setSpecialConditionDetail([]);
      setShowSCDetail(false);
    }
    const [customFilterValue, setCustomFilterValue] = useState('');
    const [enduserFilterValue,setenduserFilterValue]=useState('');
    const [pressFilterValue, setpressFilterValue]=useState('');
    const [selectedvalue, setselectedvalue]=useState([]);
    const [IdFilter,setIdFilter]=useState("");
    const [specialConditionType,setSpecialConditionType]=useState("");
    const [selectedvalue_start, setselectedvalue_start]=useState([]);
    const ConfigColumns = [{
        id: 'idSpecialCondition',
        label: t('Special Condition'),
        filter: (
          <Search
            id="customer-search"
            value={IdFilter}
            onChange={(value)=>{
              setIdFilter(value);
            }}
          />
        )
      },
      {
        id: 'specialConditionType',
        label: t('Special Condition Type'),
        filter: (
          <Search
            id="customer-search"
            value={specialConditionType}
            onChange={(value)=>{
              setSpecialConditionType(value);
            }}
          />
        )
      },
      {
        id: 'customerName',
        label: t('customerName'),
        filter: (
          <Search
            id="customer-search"
            value={customFilterValue}
            onChange={(value) => setCustomFilterValue(value)}
            
          />
        )
      },
      {
        id: 'endUserName',
        label: t('endUserName'),
        filter: (
          <Search
            id="Eneduser-search"
            value={enduserFilterValue}
            onChange={setenduserFilterValue}
          />
        )
      },
      {
        id:"startDate",
        label: t('specialcondition.startdate'),
        filter:(
          <Select
            id="table-filter-startdate"
            options={selectStartDate}
            onChange={(value)=>{
              setselectedvalue_start([value.value])
            }}
            onClear={() => setselectedvalue_start([])}
            value={selectedvalue_start}
          />
        )
      },
      {
        id:"endDate",
        label: t('specialcondition.enddate'),
        filter:(
          <Select
            id="table-filter-enddate"
            options={selectEnddate}
            onChange={(value)=>{
              setselectedvalue([value.value])
            }}
            onClear={() => setselectedvalue([])}
            value={selectedvalue}
          />
        )
      },
      {
        id:"idPress",
        label: t('pressid'),
        filter: (
          <Search
            id="Press-search"
            value={pressFilterValue}
            onChange={setpressFilterValue}
          />
        )
      }
    ];
    const [orderBy, setOrderBy] = useState('idSpecialCondition');
    const [orderType, setOrderType] = useState('descending');
    const [order, setOrder] = useState(ConfigColumns.map((c) => c.id));
    const [orderActive, setOrderActive] = useState(
      ConfigColumns.map((c) => c.id)
    );
    const handleOnColumnReorder = (newOrder) => {
        setOrderActive(newOrder);
        setOrder(newOrder);
    };
    let filteredData=filter(tableData,
      {
        idSpecialCondition: IdFilter,
        specialConditionType: specialConditionType, 
        customerName: customFilterValue, 
        endUserName: enduserFilterValue, 
        idPress:pressFilterValue,
        endDate:selectedvalue,
        startDate:selectedvalue_start
      }
    );
    let pagdata=sort(filteredData, orderBy, orderType).slice(
      (currentPage - 1) * pageSize,
      (currentPage - 1) * pageSize + pageSize
    );
    const handleSort = (_, { id, type }) => {
        setOrderBy(id);
        setOrderType(type);
    };
    
    return (
      <>
        <div>
          {t("desc_activ")}
        </div>
        <Table onClick={activateLasers} id='SpecialConditionsActive'
          columns={ConfigColumns}
          data={pagdata}
          showFilters
          onColumnReorder={handleOnColumnReorder}
          columnReorder
          onSort={handleSort}
          loading={isLoading}
          preferences={{
            defaultOrder: ConfigColumns.map((c) => c.idSpecialCondition),
            order,
            sortBy: {
              id: orderBy,
              type: orderType,
            },
            
            width: [
              {
                columnId: 'idSpecialCondition', width: 150
              },
              {
                columnId: 'specialConditionType', width: 150
              },
              {
                columnId: 'customerName', width: 230
              },
              {
                columnId: 'endUserName', width: 230
              },
              
              {
                columnId: 'startDate', width: 150
              },
              {
                columnId: 'endDate', width: 150
              },
              {
                columnId: 'idPress', width: 230
              },
            ]
          }}
          pagination={{
            currentPage,
            onPageChange: handlePageChange,
            pageSize,
            totalItems: filteredData.length,
          }}
        />
        <div style={{ textAlign: 'left' }}>
          <Button
          onClick={()=>{

            setTimeout(() => {
              let data=filteredData;
              let headerEndUsers = [
                'idSpecialCondition',
                'customerName',
                'endUserName',
                'opd',
                'startDate',
                'endDate',
                'idPress'
              ];
              const dataXlsx = data.map((item) => {
                return item;
              });
              const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: headerEndUsers });
              const wb = XLSX.utils.book_new();
              const date = moment(new Date()).format('YYYYMMDDHHmm');
              const filename = 'SpecialConditionReportActive-' + date + '.xlsx';
              const ws_name = "SpecialConditionReportActive";
              XLSX.utils.book_append_sheet(wb, ws, ws_name);
              XLSX.writeFile(wb, filename);
            }, 750);

          }}
          disabled={filteredData.length === 0}
          leadingIcon={<IconDownload />}
            title={t('download data')}
           
          >
            {t('download')}
          </Button>
        </div>
        <SpecialConditionDetail 
          onShowModal={showSCDetail}
          onCloseSCDetailsModal={onClodeModal} 
          SpecialConditionDetail={specialConditionDetail}
          setidSC={setidSC}
        />
      </>
    );
  }
  
  const MyTableApp_in = () => {
    const [showSCDetail, setShowSCDetail] = useState(false);
    const [specialConditionDetail, setSpecialConditionDetail] = useState([]);
    function activateLasers_in(e) {
      var id = $(e.target).closest('tr').children().eq(0).text();
      if (id!=t('Special Condition') && id!=""){
        let sc = tableDataIn.find(sc => sc.idSpecialCondition == id);

        setSpecialConditionDetail(sc);
        setShowSCDetail(true);
      }
    }
    const onClodeModal = () => {
      setSpecialConditionDetail([]);
      setShowSCDetail(false);
    }
    const ConfigColumns = [
      {
        id: 'idSpecialCondition',
        label: t('Special Condition'),
      },
      {
        id: 'specialConditionType',
        label: t('Special Condition Type'),
      },
      {
        id: 'customerName',
        label: t('customerName'),
      },
      {
        id: 'endUserName',
        label: t('endUserName'),
      },
      {
        id:"startDate",
        label: t('specialcondition.startdate'),
      },
      {
        id:"endDate",
        label: t('specialcondition.enddate'),
      },
      {
        id:"idPress",
        label: t('pressid'),
      }
    ];
    const [customFilterValue_in, setCustomFilterValue_in] = useState("");
    const [enduserFilterValue_in,setenduserFilterValue_in]=useState("");
    const [pressFilterValue_in, setpressFilterValue_in]=useState("");
    const [orderBy_in, setOrderBy_in] = useState('idSpecialCondition');
    const [orderType_in, setOrderType_in] = useState('descending');
    const [selectedvalue_in, setselectedvalue_in]=useState([]);
    const [selectedvalue_start_in, setselectedvalue_start_in]=useState([]);
    const [IdFilter_in,setIdFilter_in]=useState("");
    const [specialConditionType_in,setspecialConditionType_in]=useState("");
    const [order, setOrder] = useState(ConfigColumns.map((c) => c.id));
    const [orderActive, setOrderActive] = useState(
      ConfigColumns.map((c) => c.id)
    );
    const handleOnColumnReorder = (newOrder) => {
        setOrderActive(newOrder);
        setOrder(newOrder);
    };
    let filteredData_in=filter(tableDataIn,
      {
        idSpecialCondition:IdFilter_in,
        specialConditionType: specialConditionType_in, 
        customerName: customFilterValue_in, 
        endUserName: enduserFilterValue_in, 
        idPress:pressFilterValue_in,
        endDate:selectedvalue_in,
        startDate:selectedvalue_start_in
      }
    );
    let pagedata_in=sort(filteredData_in, orderBy_in, orderType_in).slice(
      (currentPage_in - 1) * pageSize,
      (currentPage_in - 1) * pageSize + pageSize
    );
    const handleSort_in = (_, { id, type }) => {
        setOrderBy_in(id);
        setOrderType_in(type);
    };
    return (
      <>
        <div>
          {t("desc_inactiv")}
        </div>
        <Table  onClick={activateLasers_in} id='SpecialConditionsInActive'
          columns={[
            {
              id: 'idSpecialCondition',
              label: t('Special Condition'),
              filter: (
                <Search
                  id="customer-search"
                  value={IdFilter_in}
                  onChange={setIdFilter_in}
                />
              )
            },
            {
              id: 'specialConditionType',
              label: t('Special Condition Type'),
              filter: (
                <Search
                  id="customer-search"
                  value={specialConditionType_in}
                  onChange={(value)=>{
                    setspecialConditionType_in(value);
                  }}
                />
              )
            },
            {
              id: 'customerName',
              label: t('customerName'),
              filter: (
                <Search
                  id="customer-search"
                  value={customFilterValue_in}
                  onChange={setCustomFilterValue_in}
                />
              )
            },
            {
              id: 'endUserName',
              label: t('endUserName'),
              filter: (
                <Search
                  id="Enduser-search"
                  value={enduserFilterValue_in}
                  onChange={setenduserFilterValue_in}
                />
              )
            },
            {
              id:"startDate",
              label: t('specialcondition.startdate'),
              filter:(
                <Select
                  id="table-filter-startdate"
                  options={selectStartDate_in}
                  onChange={(value)=>{
                    setselectedvalue_start_in([value.value])
                  }}
                  onClear={() => setselectedvalue_start_in([])}
                  value={selectedvalue_start_in}
                />
              )
            },
            {
              id:"endDate",
              label: t('specialcondition.enddate'),
              filter:(
                <Select
                  id="table-filter-enddate2"
                  options={selectEnddate_in}
                  onChange={(value)=>{
                    setselectedvalue_in([value.value])
                  }}
                  onClear={() => setselectedvalue_in([])}
                  value={selectedvalue_in}
                />
              )
            },
            {
              id:"idPress",
              label: t('pressid'),
              filter: (
                <Search
                  id="Press-search"
                  value={pressFilterValue_in}
                  onChange={setpressFilterValue_in}
                />
              )
            }
          ]}
          data={pagedata_in}
          showFilters
          onColumnReorder={handleOnColumnReorder}
          columnReorder
          onSort={handleSort_in}
          loading={isLoading}
          preferences={{
            defaultOrder: ConfigColumns.map((c) => c.idSpecialCondition),
            order,
            sortBy: {
              id: 'idSpecialCondition',
              type: 'ascending',
              id: orderBy_in,
              type: orderType_in,
            },
            width: [
              {
                columnId: 'idSpecialCondition', width: 150
              },
              {
                columnId: 'specialConditionType', width: 150
              },
              {
                columnId: 'customerName', width: 230
              },
              {
                columnId: 'endUserName', width: 230
              },
              
              {
                columnId: 'startDate', width: 150
              },
              {
                columnId: 'endDate', width: 150
              },
              {
                columnId: 'idPress', width: 230
              },
            ]
          }}
          pagination={{
            currentPage_in,
            onPageChange: handlePageChange_in,
            pageSize,
            totalItems: filteredData_in.length,
          }}
        />
        <div style={{ textAlign: 'left' }}>
          <Button
          onClick={()=>{

            let data = filteredData_in;
            setTimeout(() => {
              let headerEndUsers = [
                'idSpecialCondition',
                'customerName',
                'endUserName',
                'opd',
                'startDate',
                'endDate',
                'idPress'
              ];
              const dataXlsx = data.map((item) => {
                return item;
              });
              const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: headerEndUsers });
              const wb = XLSX.utils.book_new();
              const date = moment(new Date()).format('YYYYMMDDHHmm');
              const filename = 'SpecialConditionReportExpirade-' + date + '.xlsx';
              const ws_name = "SpecialConditionReportExpired";
              XLSX.utils.book_append_sheet(wb, ws, ws_name);
              XLSX.writeFile(wb, filename);
            }, 750);

          }}
          disabled={tableDataIn.length === 0}
          leadingIcon={<IconDownload />}
            title={t('download data')}
           
          >
            {t('download')}
          </Button>
        </div>
        <SpecialConditionDetail 
          onShowModal={showSCDetail}
          onCloseSCDetailsModal={onClodeModal} 
          SpecialConditionDetail={specialConditionDetail}
          setidSC={setidSC}
        />
      </>
    );
  }
  
  const MyTableApp_stan = () => {

    const [showSCDetail, setShowSCDetail] = useState(false);
    const [specialConditionDetail, setSpecialConditionDetail] = useState([]);
    function activateLasers_stan(e) {
      var id = $(e.target).closest('tr').children().eq(0).text();
      if (id!=t('Special Condition') && id!=""){
          let sc = tableDataStand.find(sc => sc.idSpecialCondition == id);
          setSpecialConditionDetail(sc);
          setShowSCDetail(true);
      }
    }
    const onClodeModal = () => {
      setSpecialConditionDetail([]);
      setShowSCDetail(false);
    }
    const [orderBy_stan, setOrderBy_stan] = useState('name');
    const [orderType_stan, setOrderType_stan] = useState('ascending');
    const [customFilterValue_stan, setCustomFilterValue_stan] = useState("");  
    const [enduserFilterValue_stan,setenduserFilterValue_stan]=useState("");
    const [pressFilterValue_stan, setpressFilterValue_stan]=useState("");
    const [selectedvalue_stan, setselectedvalue_stan]=useState([]);
    const [selectedvalue_start_stan, setselectedvalue_start_stan]=useState([]);
    const [IdFilter_stan,setIdFilter_stan]=useState("");
    const [specialConditionType_stan,setSpecialConditionType_stan]=useState("");
    const ConfigColumns = [
      {
        id: 'idSpecialCondition',
        label: t('Special Condition'),
        filter:(
          <Search 
            id="customer-search"
            value={IdFilter_stan}
            onChange={setIdFilter_stan}
          />
        )
      },
      {
        id: 'specialConditionType',
        label: t('Special Condition Type'),
        filter: (
          <Search
            id="customer-search"
            value={specialConditionType_stan}
            onChange={(value)=>{
              setSpecialConditionType_stan(value);
            }}
          />
        )
      },
      {
        id: 'customerName',
        label: t('customerName'),
        filter: (
          <Search
            id="customer-search"
            value={customFilterValue_stan}
            onChange={setCustomFilterValue_stan}
          />
        )
      },
      {
        id: 'endUserName',
        label: t('endUserName'),
        filter: (
          <Search
            id="Enduser-search"
            value={enduserFilterValue_stan}
            onChange={setenduserFilterValue_stan}
          />
        )
      },
      {
        id:"startDate",
        label: t('specialcondition.startdate'),
        filter:(
          <Select
            id="table-filter-startdate"
            options={selectStartDate_stan}
            onChange={(value)=>{
              setselectedvalue_start_stan([value.value])
            }}
            onClear={() => setselectedvalue_start_stan([])}
            value={selectedvalue_start_stan}
          />
        )
      },
      {
        id:"endDate",
        label: t('specialcondition.enddate'),
        filter:(
          <Select
            id="table-filter-enddate4"
            options={selectEnddate_stan}
            onChange={(value)=>{
              setselectedvalue_stan([value.value])
            }}
            onClear={() => setselectedvalue_stan([])}
            value={selectedvalue_stan}
          />
        )              
      },
      {
        id:"idPress",
        label: t('pressid'),
        filter: (
          <Search
            id="Press-search"
            value={pressFilterValue_stan}
            onChange={setpressFilterValue_stan}
          />
        )
      }
    ];
    const handleOnColumnReorder = (newOrder) => {
        setOrderActive(newOrder);
        setOrder(newOrder);
    };
    const [order, setOrder] = useState(ConfigColumns.map((c) => c.id));
    const [orderActive, setOrderActive] = useState(
      ConfigColumns.map((c) => c.id)
    );
    let filteredData_stan=filter(tableDataStand,
      {
        idSpecialCondition:IdFilter_stan,
        specialConditionType: specialConditionType_stan, 
        customerName: customFilterValue_stan, 
        endUserName: enduserFilterValue_stan, 
        idPress:pressFilterValue_stan ,
        endDate:selectedvalue_stan,
        startDate:selectedvalue_start_stan
      }
    );

    let pagdata_stan = sort(filteredData_stan, orderBy_stan, orderType_stan).slice(
      (currentPage_stan - 1) * pageSize,
      (currentPage_stan - 1) * pageSize + pageSize
    );

    const handleSort_stand = (_, { id, type }) => {
        setOrderBy_stan(id);
        setOrderType_stan(type);
    };
    return (
      <>
        <div>
          {t("desc_stand")}
        </div>
        <Table  onClick={activateLasers_stan} id='SpecialConditionsStand'
          columns={ConfigColumns}
          data={pagdata_stan}
          showFilters
          columnReorder
          onColumnReorder={handleOnColumnReorder}
          onSort={handleSort_stand}
          loading={isLoading}
          preferences={{
            defaultOrder: ConfigColumns.map((c) => c.idSpecialCondition),
            order,
            sortBy: {
              id: orderBy_stan,
              type: orderType_stan,
            },
            width: [
              {
                columnId: 'idSpecialCondition', width: 150
              },
              {
                columnId: 'specialConditionType', width: 150
              },
              {
                columnId: 'customerName', width: 230
              },
              {
                columnId: 'endUserName', width: 230
              },
              
              {
                columnId: 'startDate', width: 150
              },
              {
                columnId: 'endDate', width: 150
              },
              {
                columnId: 'idPress', width: 230
              },
            ]
          }}
          pagination={{
            currentPage_stan,
            onPageChange: handlePageChange_stan,
            pageSize,
            totalItems: filteredData_stan.length,
          }}
        />
        <div style={{ textAlign: 'left' }}>
          <Button
          onClick={()=>{

            let data = filteredData_stan;
            setTimeout(() => {
              let headerEndUsers = [
                'idSpecialCondition',
                'customerName',
                'endUserName',
                'opd',
                'startDate',
                'endDate',
                'idPress'
              ];
              const dataXlsx = data.map((item) => {
                return item;
              });
              const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: headerEndUsers });
              const wb = XLSX.utils.book_new();
              const date = moment(new Date()).format('YYYYMMDDHHmm');
              const filename = 'SpecialConditionReportStand-' + date + '.xlsx';
              const ws_name = "SpecialConditionReportStand";
              XLSX.utils.book_append_sheet(wb, ws, ws_name);
              XLSX.writeFile(wb, filename);
            }, 750);
          }}
          disabled={filteredData_stan.length === 0}
          leadingIcon={<IconDownload />}
            title={t('download data')}
           
          >
            {t('download')}
          </Button>
        </div>
        <SpecialConditionDetail 
          onShowModal={showSCDetail}
          onCloseSCDetailsModal={onClodeModal} 
          SpecialConditionDetail={specialConditionDetail}
          setidSC={setidSC}
        />
      </>
    );
  }
  
  const MyTableApp__reject=()=>{
    const [showSCDetail, setShowSCDetail] = useState(false);
    const [specialConditionDetail, setSpecialConditionDetail] = useState([]);
    function activateLasers_rej(e) {
      var id = $(e.target).closest('tr').children().eq(0).text();
      if (id!=t('Special Condition') && id!=""){
          let sc = tableRejected.find(sc => sc.idSpecialCondition == id);
          setSpecialConditionDetail(sc);
          setShowSCDetail(true);
      }
    }
    const onClodeModal = () => {
      setSpecialConditionDetail([]);
      setShowSCDetail(false);
    }
    const ConfigColumns = [
      {
        id: 'idSpecialCondition',
        label: t('Special Condition'),
      },
      {
        id: 'specialConditionType',
        label: t('Special Condition Type'),
      },
      {
        id: 'customerName',
        label: t('customerName'),
      },
      {
        id: 'endUserName',
        label: t('endUserName'),
      },
      {
        id:"startDate",
        label: t('specialcondition.startdate'),
      },
      {
        id:"endDate",
        label: t('specialcondition.enddate'),
      },
      {
        id:"idPress",
        label: t('pressid'),
      }
    ];
    
    const [customFilterValue_reject, setCustomFilterValue_reject] = useState("");  
    const [enduserFilterValue_reject,setenduserFilterValue_reject]=useState("");
    const [pressFilterValue_reject, setpressFilterValue_reject]=useState("");
    const [orderBy_reject, setOrderBy_reject] = useState('idSpecialCondition');
    const [orderType_reject, setOrderType_reject] = useState('descending');
    const [selectedvalue_reject, setselectedvalue_reject]=useState([]);
    const [selectedvalue_start_reject, setselectedvalue_start_reject]=useState([]);
    const [IdFilter_reject,setIdFilter_reject]=useState("");
    const [specialConditionType_reject,setSpecialConditionType_reject]=useState("");
    const [order, setOrder] = useState(ConfigColumns.map((c) => c.id));
    const [orderActive, setOrderActive] = useState(
      ConfigColumns.map((c) => c.id)
    );
    const handleOnColumnReorder = (newOrder) => {
        setOrderActive(newOrder);
        setOrder(newOrder);
    };
    let filteredData_reject=filter(tableRejected,
      {
        idSpecialCondition: IdFilter_reject,
        specialConditionType: specialConditionType_reject, 
        customerName: customFilterValue_reject, 
        endUserName: enduserFilterValue_reject, 
        idPress:pressFilterValue_reject ,
        endDate:selectedvalue_reject,
        startDate:selectedvalue_start_reject
      }
    );
    let pagdata_reject = sort(filteredData_reject, orderBy_reject, orderType_reject).slice(
      (currentPage_rej - 1) * pageSize,
      (currentPage_rej - 1) * pageSize + pageSize
    );

    const handleSort_reject = (_, { id, type }) => {
        setOrderBy_reject(id);
        setOrderType_reject(type);
    };

    return (
      <>
        <div>
          {t("desc_reject")}
        </div>
        <Table  onClick={activateLasers_rej} id='SpecialConditionsReject'
          columns={[
            {
              id: 'idSpecialCondition',
              label: t('Special Condition'), 
              filter:(
                <Search 
                  id="customer-search"
                  value={IdFilter_reject}
                  onChange={setIdFilter_reject}
                />
              )
            },
            {
              id: 'specialConditionType',
              label: t('Special Condition Type'),
              filter: (
                <Search
                  id="customer-search"
                  value={specialConditionType_reject}
                  onChange={(value)=>{
                    setSpecialConditionType_reject(value);
                  }}
                />
              )
            },
            {
              id: 'customerName',
              label: t('customerName'),
              filter: (
                <Search
                  id="customer-search"
                  value={customFilterValue_reject}
                  onChange={setCustomFilterValue_reject}
                />
              )
            },
            {
              id: 'endUserName',
              label: t('endUserName'),
              filter: (
                <Search
                  id="Enduser-search"
                  value={enduserFilterValue_reject}
                  onChange={setenduserFilterValue_reject}
                />
              )
            },
            {
              id:"startDate",
              label: t('specialcondition.startdate'),
              filter:(
                <Select
                  id="table-filter-startdate"
                  options={selectStartDate_rej}
                  onChange={(value)=>{
                    setselectedvalue_start_reject([value.value])
                  }}
                  onClear={() => setselectedvalue_start_reject([])}
                  value={selectedvalue_start_reject}
                />
              )
            },
            {
              id:"endDate",
              label: t('specialcondition.enddate'),
              filter:(
                <Select
                  id="table-filter-enddate4"
                  options={selectEnddate_rej}
                  onChange={(value)=>{
                    setselectedvalue_reject([value.value])
                  }}
                  onClear={() => setselectedvalue_reject([])}
                  value={selectedvalue_reject}
                />
              )              
            },
            {
              id:"idPress",
              label: t('pressid'),
              filter: (
                <Search
                  id="Press-search"
                  value={pressFilterValue_reject}
                  onChange={setpressFilterValue_reject}
                />
              )
            }
          ]}
          data={pagdata_reject}
          showFilters
          columnReorder
          onColumnReorder={handleOnColumnReorder}
          onSort={handleSort_reject}
          loading={isLoading}
          preferences={{
            defaultOrder: ConfigColumns.map((c) => c.idSpecialCondition),
            order,
            sortBy: {
              id: orderBy_reject,
              type: orderType_reject,
            },
            width: [
              {
                columnId: 'idSpecialCondition', width: 150
              },
              {
                columnId: 'specialConditionType', width: 150
              },
              {
                columnId: 'customerName', width: 230
              },
              {
                columnId: 'endUserName', width: 230
              },
              
              {
                columnId: 'startDate', width: 150
              },
              {
                columnId: 'endDate', width: 150
              },
              {
                columnId: 'idPress', width: 230
              },
            ]
          }}
          pagination={{
            currentPage_rej,
            onPageChange: handlePageChange_rej,
            pageSize,
            totalItems: filteredData_reject.length,
          }}
        />
        <div style={{ textAlign: 'left' }}>
          <Button
          onClick={()=>{

            let data = filteredData_reject;
            setTimeout(() => {
              let headerEndUsers = [
                'idSpecialCondition',
                'customerName',
                'endUserName',
                'opd',
                'startDate',
                'endDate',
                'idPress'
              ];
              const dataXlsx = data.map((item) => {
                return item;
              });
              const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: headerEndUsers });
              const wb = XLSX.utils.book_new();
              const date = moment(new Date()).format('YYYYMMDDHHmm');
              const filename = 'SpecialConditionReportReject-' + date + '.xlsx';
              const ws_name = "SpecialConditionReportIReject";
              XLSX.utils.book_append_sheet(wb, ws, ws_name);
              XLSX.writeFile(wb, filename);
            }, 750);
          }}
          disabled={filteredData_reject.length === 0}
          leadingIcon={<IconDownload />}
            title={t('download data')}
           
          >
            {t('download')}
          </Button>
        </div>
        <SpecialConditionDetail 
          onShowModal={showSCDetail}
          onCloseSCDetailsModal={onClodeModal} 
          SpecialConditionDetail={specialConditionDetail}
          setidSC={setidSC}
        />
      </>
    );
  }

  const MyTableApp__pending=()=>{
    const [showSCDetail, setShowSCDetail] = useState(false);
    const [specialConditionDetail, setSpecialConditionDetail] = useState([]);
    function activateLasers_pend(e) {
      var id = $(e.target).closest('tr').children().eq(0).text();
      if (id!=t('Special Condition') && id!=""){
          let sc = tablePending.find(sc => sc.idSpecialCondition == id);
          setSpecialConditionDetail(sc);
          setShowSCDetail(true);
      }
    }
    const onClodeModal = () => {
      setSpecialConditionDetail([]);
      setShowSCDetail(false);
    }
    const ConfigColumns = [
      {
        id: 'idSpecialCondition',
        label: t('Special Condition'),
      },
      {
        id: 'specialConditionType',
        label: t('Special Condition Type'),
      },
      {
        id: 'customerName',
        label: t('customerName'),
      },
      {
        id: 'endUserName',
        label: t('endUserName'),
      },
      {
        id:"startDate",
        label: t('specialcondition.startdate'),
      },
      {
        id:"endDate",
        label: t('specialcondition.enddate'),
      },
      {
        id:"idPress",
        label: t('pressid'),
      }
    ];
    const [customFilterValue_pending, setCustomFilterValue_pending] = useState("");  
    const [enduserFilterValue_pending,setenduserFilterValue_pending]=useState("");
    const [pressFilterValue_pending, setpressFilterValue_pending]=useState("");
    const [orderBy_pending, setOrderBy_pending] = useState('name');
    const [orderType_pending, setOrderType_pending] = useState('ascending');
    const [selectedvalue_pending, setselectedvalue_pending]=useState([]);
    const [selectedvalue_start_pending, setselectedvalue_start_pending]=useState([]);
    const [IdFilter_pending,setIdFilter_pending]=useState("");
    const [specialConditionType_pending,setSpecialConditionType_pending]=useState("");
    const [order, setOrder] = useState(ConfigColumns.map((c) => c.id));
    const [orderActive, setOrderActive] = useState(
      ConfigColumns.map((c) => c.id)
    );
    const handleOnColumnReorder = (newOrder) => {
        setOrderActive(newOrder);
        setOrder(newOrder);
    };
    let filteredData_pending=filter(tablePending,
      {
        idSpecialCondition:IdFilter_pending,
        specialConditionType: specialConditionType_pending, 
        customerName: customFilterValue_pending, 
        endUserName: enduserFilterValue_pending, 
        idPress: pressFilterValue_pending ,
        endDate: selectedvalue_pending,
        startDate:selectedvalue_start_pending
      }
    );
    let pagdata_pending = sort(filteredData_pending, orderBy_pending, orderType_pending).slice(
      (currentPage_pen - 1) * pageSize,
      (currentPage_pen - 1) * pageSize + pageSize
    );
    const handleSort_pending = (_, { id, type }) => {
        setOrderBy_pending(id);
        setOrderType_pending(type);
    };
    //console.log(pagdata_pending);
    //console.log(filteredData_pending);
    //console.log(tablePending);
    //console.log("salida de tablas--.....");
    return (
      <>
        <div>
          {t("desc_pending")}
        </div>
        <Table  onClick={activateLasers_pend} id='SpecialConditionsPending'
          columns={[
            {
              id: 'idSpecialCondition',
              label: t('Special Condition'),
              filter:(
                <Search 
                  id="customer-search"
                  value={IdFilter_pending}
                  onChange={setIdFilter_pending}
                />
              )
            },
            {
              id: 'specialConditionType',
              label: t('Special Condition Type'),
              filter: (
                <Search
                  id="customer-search"
                  value={specialConditionType_pending}
                  onChange={(value)=>{
                    setSpecialConditionType_pending(value);
                  }}
                />
              )
            },
            {
              id: 'customerName',
              label: t('customerName'),
              filter: (
                <Search
                  id="customer-search"
                  value={customFilterValue_pending}
                  onChange={(val)=>{
                    setCustomFilterValue_pending(val);
                    setCurrentPage_pen(1);
                  }}
                />
              )
            },
            {
              id: 'endUserName',
              label: t('endUserName'),
              filter: (
                <Search
                  id="Enduser-search"
                  value={enduserFilterValue_pending}
                  onChange={setenduserFilterValue_pending}
                />
              )
            },
            {
              id:"startDate",
              label: t('specialcondition.startdate'),
              filter:(
                <Select
                  id="table-filter-startdate"
                  options={selectStartDate_pend}
                  onChange={(value)=>{
                    setselectedvalue_start_pending([value.value])
                  }}
                  onClear={() => setselectedvalue_start_pending([])}
                  value={selectedvalue_start_pending}
                />
              )
            },
            {
              id:"endDate",
              label: t('specialcondition.enddate'),
              filter:(
                <Select
                  id="table-filter-enddate4"
                  options={selectEnddate_pend}
                  onChange={(value)=>{
                    setselectedvalue_pending([value.value])
                  }}
                  onClear={() => setselectedvalue_pending([])}
                  value={selectedvalue_pending}
                />
              )              
            },
            {
              id:"idPress",
              label: t('pressid'),
              filter: (
                <Search
                  id="Press-search"
                  value={pressFilterValue_pending}
                  onChange={setpressFilterValue_pending}
                />
              )
            }
          ]}
          data={pagdata_pending}
          showFilters
          columnReorder
          onColumnReorder={handleOnColumnReorder}
          onSort={handleSort_pending}
          loading={isLoading}
          preferences={{
            defaultOrder: ConfigColumns.map((c) => c.idSpecialCondition),
            order,
            sortBy: {
              id: orderBy_pending,
              type: orderType_pending,
            },
            width: [
              {
                columnId: 'idSpecialCondition', width: 150
              },
              {
                columnId: 'specialConditionType', width: 150
              },
              {
                columnId: 'customerName', width: 230
              },
              {
                columnId: 'endUserName', width: 230
              },
              
              {
                columnId: 'startDate', width: 150
              },
              {
                columnId: 'endDate', width: 150
              },
              {
                columnId: 'idPress', width: 230
              },
            ]
          }}
          pagination={{
            currentPage_pen,
            onPageChange: handlePageChange_pen,
            pageSize,
            totalItems: filteredData_pending.length,
          }}
        />
        <div style={{ textAlign: 'left' }}>
          <Button
          onClick={()=>{

            let data = filteredData_pending;
            setTimeout(() => {
              let headerEndUsers = [
                'idSpecialCondition',
                'customerName',
                'endUserName',
                'opd',
                'startDate',
                'endDate',
                'idPress'
              ];
              const dataXlsx = data.map((item) => {
                return item;
              });
              const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: headerEndUsers });
              const wb = XLSX.utils.book_new();
              const date = moment(new Date()).format('YYYYMMDDHHmm');
              const filename = 'SpecialConditionReportReject-' + date + '.xlsx';
              const ws_name = "SpecialConditionReportReject";
              XLSX.utils.book_append_sheet(wb, ws, ws_name);
              XLSX.writeFile(wb, filename);
            }, 750);
          }}
          disabled={filteredData_pending.length === 0}
          leadingIcon={<IconDownload />}
            title={t('download data')}
           
          >
            {t('download')}
          </Button>
        </div>
        <SpecialConditionDetail 
          onShowModal={showSCDetail}
          onCloseSCDetailsModal={onClodeModal} 
          SpecialConditionDetail={specialConditionDetail}
          setidSC={setidSC}
        />
      </>
    );
  }

  let list=[
    { id: 0, label: t("active"), content: <div style={{ padding: '30px' }}><MyTableApp /></div>},
    { id: 1, label: t("inactive"), content: <div style={{ padding: '30px' }}><MyTableApp_stan/></div>},
    { id: 2, label: t("expired"), content: <div style={{ padding: '30px' }}><MyTableApp_in/></div>},
    { id: 3, label: t("Rejected"), content: <div style={{ padding: '30px' }}><MyTableApp__reject/></div>}
  ];
  if (authenticationService.currentUserValue.idRole==1 || authenticationService.currentUserValue.idRole==8){
    list.push({ id: 4, label: t("Pending"), content: <div style={{ padding: '30px' }}><MyTableApp__pending/></div> });
  }
  return(<>
      <Tabs
        controlId="default"
        onChangeTab={selectTab()}
        selectedTabId={activeTabIndex}
        tabs={list}
      />
  </>);
}

export default SpecialConditionReport;